<script>
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import Dashboard from '../../Models/dashboardModel';
    import { uuid } from '../../Database.svelte';
    import { onMount } from 'svelte';

    import {addFormModal} from '../../Forms/ModalFormManager.svelte';
    import {forms} from '../../lib/forms';
    import { confirm } from '../Confirmation.svelte';

    export let params;

    let table_fields = [
        {
            field: "name",
            label: "Field Name"
        },
        {
            field: "type",
            label: "Field Type"
        },
        {
            field: "required",
            label: "Required"
        },
        {
            field: "show_in_table",
            label: "Show in Table"
        }
    ]

    let dashboard_model;
    let dashboard;
    let details;

    function addField() {
        addFormModal({
            fields: forms['dashboardItem']
        }).then(saveField).catch(() => {});
    }

    function editField(field) {
        addFormModal({
            fields: forms['dashboardItem'],
            data: field
        }).then(saveField).catch(() => {});
    }

    function saveField(field) {
        if (field.id) {
            details.fields = details.fields.map(f => {
                if (f.id == field.id) {
                    return field
                }
                return f
            })
        } else {
            field.id = uuid();
            details.fields = [...details.fields, field];
        }

        saveDashboard()
    }

    function saveDashboard() {
        Dashboard.updateDashboard(details);
    }

    function removeField(field) {
        confirm(`Are you sure you want to remove ${field.name}?`).then(() => {
            details.fields = details.fields.filter(f => f.id != field.id);
            saveDashboard()
        }).catch(() => {});
    }

    onMount(() => {
        dashboard_model = new Dashboard(params.id);
        dashboard = dashboard_model.getDashboardStore();

        const unsub = dashboard.subscribe((dash) => {
            if (dash) {
                details = dash.details;
            }
        })

        return unsub;
    })
</script>

<Loader loading={!details}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            Edit Dashboard
            <a href="#/dashboards" class="button is-pulled-right">Close</a>
        </h1>
        <div class="field is-horizontal is-large">
            <div class="field-label is-narrow is-large">
                <label class="label">Dashboard Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input class="input is-large" type="text" bind:value={details.name} on:blur={saveDashboard}>
                    </div>
                </div>
            </div>
        </div>

        <SortableTable sortFields={table_fields} tableData={details.fields} rowKey="id">
            <tr slot="topRow">
                <td>Name</td>
                <td>text</td>
                <td>true</td>
                <td></td>
            </tr>
            <div slot="rowActions" let:row={field}>
                <button class="button is-info" on:click={() => editField(field)}>Edit</button>
                <button class="button is-danger" on:click={() => removeField(field)}>Delete</button>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addField}>Add Field</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>